import * as React from "react";
import ContactForm from "@components/ContactForm";
import * as styles from "./Events.module.scss";

import upcomingEventsGraphic from "@images/events/upcoming_events_graphic.svg";
import iconUpcomingEvent from "@images/events/icon_upcoming_event.svg";


const UpcomingEvents = ({ events }) => (
    <div className={styles.upcoming_events_container}>
    <div className={styles.event_inner_content}>
      <h3>Upcoming events</h3>
      <ul>
        {events.map(upcomingEvent => (
          <li className={styles.event_venue} style={{ lineHeight: "35px" }}>
            <img src={iconUpcomingEvent} />
            <p>{upcomingEvent}</p>
          </li>
        ))}
      </ul>
      </div>
      <img
        src={upcomingEventsGraphic}
        className={`${styles.featured_img} ${styles.img_one}`}
      />
    </div>
  );

export default UpcomingEvents;
